"use client";

import React, { useEffect, useState } from "react";
import { AppDispatch } from "@/redux/store";
import { useDispatch } from "react-redux";
import { validateEmail } from "@/helpers/utils/utility-functions";
import LoginModel from "./LoginModel";
import LoginViaEmail from "./LoginViaEmail";
import LoginViaSocialMedia from "./LoginViaSocialMedia";
import LoginViaPhone from "./LoginViaPhone";
import LoginOTP from "./LoginOTP";
import Image from "next/image";
import { startLoader, stopLoader } from "@/redux/features/app-slice";
import { sendLoginUrl } from "@/helpers/server-actions/actions";
import { ConfirmationResult } from "firebase/auth";

const loginMethods = {
  Email: 1,
  Phone: 2,
};

export default function Login() {
  const [loginMethod, setLoginMethod] = useState<number>(loginMethods.Email);
  const [isOtpRequested, setIsOtpRequested] = useState<boolean>(false);
  const [isEmailSent, setIsEmailSent] = useState<boolean>(false);
  const [isEmailReSent, setIsEmailReSent] = useState<boolean>(false);
  const [counter, setCounter] = useState<number>(0);
  const [email, setEmail] = useState<string>("");
  const [otpRequestedPhone, setOtpRequestedPhone] = useState<string>("");
  const [otpConfirmationResult, setOTPConfirmationResult] = useState<ConfirmationResult>();
  const dispatch = useDispatch<AppDispatch>();

  useEffect(() => {
    const timer = setInterval(() => {
      if (counter > 0) { setCounter(counter - 1); }
    }, 1000);
    return () => clearInterval(timer);
  }, [counter]);

  const handleUpdateLoginMethod = (method: number) => {
    setLoginMethod(method);
  };

  const handleOtpRequested = (otpConfirmationResponse: ConfirmationResult, phone: string) => {
    if (!phone) return;
    setOtpRequestedPhone(phone);
    setIsOtpRequested(true);
    setOTPConfirmationResult(otpConfirmationResponse);
  };

  const handleBackButton = () => {
    if (isEmailSent) {
      setIsEmailSent(false);
    } else if (isOtpRequested) {
      setIsOtpRequested(false);
    }
  };

  const handleResendEmailLink = () => {
    if (!validateEmail(email)) {
      return;
    }
    dispatch(startLoader(""));
    setCounter(59);
    const afterLoginRedirectUrl = `${window.location.href}`;
    const origin = window.location.origin;
    const redirectUrl = `${origin
      }/email-redirect?email=${encodeURIComponent(
        email
      )}&redirectUrl=${encodeURIComponent(afterLoginRedirectUrl)}`;

    sendLoginUrl(email, redirectUrl).then((isSuccess) => {

      dispatch(stopLoader());
      setCounter(59);
    });
  };

  const renderEmailPhoneInput = () => {
    if (loginMethod == loginMethods.Email) {
      return (
        <LoginViaEmail
          changeLoginMethod={() => handleUpdateLoginMethod(loginMethods.Phone)}
          handleEmailSent={(email, isEmailSent) => { setIsEmailSent(isEmailSent); setEmail(email) }}
        />
      );
    } else if (loginMethod == loginMethods.Phone) {
      return (
        <LoginViaPhone
          changeLoginMethod={() => handleUpdateLoginMethod(loginMethods.Email)}
          optRequested={handleOtpRequested}
        />
      );
    }
  };

  const renderHeadingText = () => {
    if (isEmailSent) {
      return "Check your inbox"
    } else if (isOtpRequested) {
      return "Enter Code"
    }
    else {
      return "Welcome to C-Tribe"
    }

  }

  const renderSubHeadingText = () => {
    if (isEmailSent) {
      return "Please click the sign in link we sent to"
    } else if (isOtpRequested) {
      return "Please enter the 6 digit code we sent to"
    }
    else {
      return "Sign in or sign up below"
    }

  }

  const resendEmailBlock = (
    <>
      {counter === 0 ? (
        <div className="mt-6">
          <button className="mt-4 mb-6 text-sm text-black cursor-pointer font-medium"
            onClick={() => handleResendEmailLink()}>
            Resend Link
          </button>
        </div>
      ) : (
        <div className="flex justify-center items-center mt-6 mb-6">
          <Image
            height={20}
            width={20}
            src="/images/otp_success.svg"
            alt="Resend button"
            className="mt-2"
          />
          <p className="ml-1 mb-0 mt-2 text-left text-black text-sm">
            Link resent!
          </p>
        </div>
      )}
    </>
  );

  return (
    <>
      <div className="flex items-center justify-center md:mt-0 mt-[6.25rem]">
        <LoginModel >
          <div className={`flex flex-col`}>
            {(isOtpRequested || isEmailSent) && (
              <button onClick={handleBackButton} className="mb-4">
                <Image
                  height={22}
                  width={22}
                  src="/images/back_button_login.svg"
                  alt="c-tribe"
                />
              </button>
            )}
            <span className="text-left font-semibold text-[1.375rem] leading-8 text-custom-gray">
              {renderHeadingText()}
            </span>
            <span className={`text-left mt-1 font-normal text-sm ${isEmailSent ? 'leading-5' : 'leading-7'} text-custom-gray`}>
              {renderSubHeadingText()}
            </span>
            <span className="text-left mt-1 font-medium text-sm leading-5 text-custom-gray">
              {
                isOtpRequested ? `${otpRequestedPhone}` : isEmailSent ? `${email}` : null
              }
            </span>

            {!isEmailSent ? (
              <>
                {
                  !isOtpRequested ? (
                    renderEmailPhoneInput()
                  ) : (
                    <LoginOTP
                      otpConfirmationResponse={otpConfirmationResult}
                      phoneNumber={otpRequestedPhone}
                    />
                  )
                }
              </>

            ) : null
            }


            {isEmailSent && resendEmailBlock}

            {!isOtpRequested && !isEmailSent && <LoginViaSocialMedia />}
          </div>
        </LoginModel>
      </div>
    </>
  );
}
